module.exports = __webpack_public_path__ + "static/media/default.1a7a998b.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/public/images/default.png
// module id = 606
// module chunks = 0